import * as z from "zod";

export const InternationalReturnsFlatTeamSettingsSchema = z.object({
  "returns/redoAssistedCustoms/hsCodeOptOut": z.boolean().nullish(),
  "returns/redoAssistedCustoms/customsDescriptionOptOut": z.boolean().nullish(),
  "returns/shopifyCustomsMetafields/descriptionKey": z.string().nullish(),
  "returns/shopifyCustomsMetafields/manufacturerKey": z.string().nullish(),
  "returns/shopifyCustomsMetafields/materialKey": z.string().nullish(),
  "returns/shopifyCustomsMetafields/variantDescriptionKey": z
    .string()
    .nullish(),
  "returns/shopifyCustomsMetafields/variantManufacturerKey": z
    .string()
    .nullish(),
  "returns/shopifyCustomsMetafields/variantMaterialKey": z.string().nullish(),
});
